(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delivery-basket"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("scroll", function () {
  const steps = document.querySelectorAll('.subscription-step');
  const truck = document.getElementById('truckIcon');
  const fill = document.getElementById('timelineFill');
  const stepNumbers = document.querySelectorAll('.timeline-step-number');

  const stepTops = [100, 300, 593];
  let lastVisibleIndex = -1;

  steps.forEach((step, i) => {
    const rect = step.getBoundingClientRect();
    const stepTop = rect.top + window.scrollY;
    const stepCenter = stepTop + rect.height / 2;
    const triggerPoint = window.scrollY + window.innerHeight / 2;

    if (triggerPoint >= stepCenter) {
      lastVisibleIndex = i;
    }
  });

  if (lastVisibleIndex >= 0 && lastVisibleIndex < stepTops.length) {
    const newTop = stepTops[lastVisibleIndex];
    truck.style.top = `${newTop}px`;
    fill.style.height = `${newTop + 14}px`;

    stepNumbers.forEach((el, i) => {
      if (i <= lastVisibleIndex) {
        el.classList.add('completed');
        el.innerHTML = '✓';
      } else {
        el.classList.remove('completed');
        el.innerHTML = `${i + 1}`;
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
